class CartDrawerTimer extends HTMLElement {
  connectedCallback() {
    const duration = Number(this.dataset.duration || 600) * 1000;
    const storageKey = 'jckedCartTimerEnd';

    let endTime = Number(sessionStorage.getItem(storageKey));
    if (!endTime || endTime < Date.now()) {
      endTime = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endTime));
    }

    this.endTime = endTime;
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = Math.max(0, this.endTime - Date.now());
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (remaining <= 0) {
      clearInterval(this.interval);
      sessionStorage.removeItem('jckedCartTimerEnd');
    }
  }
}

customElements.define('cart-drawer-timer', CartDrawerTimer);
